import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import PrivateRoute from '../PrivateRoute'

// Shared
import Header from '../components/Header'
import NotFoundPage from '../components/NotFoundPage'
import Login from '../components/Login'

// Panel
import Dashboard from '../components/Dashboard'
import InboxVouchers from '../components/Inbox'
import Details from '../components/Inbox/Details'
import VouchersList from '../components/Vouchers/List'
//import VouchersNew from '../components/Vouchers/New'
import VouchersEdit from '../components/Vouchers/Edit'
import Me from '../components/Me'
import Reports from '../components/Reports'

// Admin
import Users from '../components/Admin/Users'
import Roles from '../components/Admin/Roles'
import VouchersAdmin from '../components/Admin/Vouchers'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import { useAuthentication } from '../hooks/useAuthentication'
import ExportVouchers from '../components/Vouchers/ExportView'
import Workflows from '../components/Admin/Workflows'
import VouchersManagement from '../components/Admin/VouchersManagement'

const AdminWrapper: React.FC = () => {
  const { authState } = useAuthentication()

  if (authState.authUser.role !== 'ADMIN' && !authState.authUser.site_admin) {
    return <Redirect to="/panel" />
  }

  return (
    <Box overflow="auto" height={1}>
      <Header />
      <Container>
        <Box sx={{ mt: 2, mb: 3 }}>
          <Box sx={{ bgcolor: 'grey.100', p: 2, borderRadius: 1, mb: 2 }}>
            <Breadcrumbs
              aria-label="breadcrumb"
              sx={{ fontSize: '1.1rem', fontWeight: 500 }}
            >
              <Link color="inherit" href="/admin">
                Admin Home
              </Link>
              <Link color="inherit" href="/admin/users">
                Users
              </Link>
              <Link color="inherit" href="/admin/roles">
                Roles
              </Link>{' '}
              <Link color="inherit" href="/admin/workflows">
                Workflows
              </Link>
              <Link color="inherit" href="/admin/vouchers">
                Vouchers
              </Link>
            </Breadcrumbs>
          </Box>
        </Box>
        <Switch>
          <Route exact path="/admin">
            <Typography variant="h4" gutterBottom>
              Admin Dashboard
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Welcome to the admin section. Use the navigation to manage users
              and other administrative tasks.
            </Typography>
            <Box>
              <Typography variant="h6" gutterBottom>
                Available Admin Functions:
              </Typography>
              <ul>
                <li>
                  <Link href="/admin/users" color="primary">
                    Users Management
                  </Link>{' '}
                  - View and manage user accounts
                </li>
                <li>
                  <Link href="/admin/roles" color="primary">
                    Roles Management
                  </Link>{' '}
                  - View and manage user roles
                </li>
                <li>
                  <Link href="/admin/workflows" color="primary">
                    Workflows Management
                  </Link>{' '}
                  - View and manage workflows
                </li>
                <li>
                  <Link href="/admin/vouchers" color="primary">
                    Vouchers Management
                  </Link>{' '}
                  - View and manage all vouchers
                </li>
                <li>
                  <Link href="/admin/export" color="primary">
                    Export Vouchers
                  </Link>{' '}
                  - Export all vouchers
                </li>
              </ul>
            </Box>
          </Route>
          <Route path="/admin/users" component={Users} />
          <Route path="/admin/roles" component={Roles} />
          <Route path="/admin/workflows" component={Workflows} />
          <Route path="/admin/vouchers" component={VouchersManagement} />
        </Switch>
      </Container>
    </Box>
  )
}

const PanelWrapper: React.FC = () => {
  return (
    <Box overflow="auto" height={1}>
      <Header />
      <Container>
        <Switch>
          {/* Dashboard */}
          <Route exact path="/panel" component={Dashboard} />

          {/* Inbox */}
          <Route exact path="/panel/inbox" component={InboxVouchers} />
          <Route path="/panel/inbox/:id/edit" component={Details} />

          {/* Vouchers */}
          <Route exact path="/panel/vouchers" component={VouchersList} />
          {/* <Route path="/panel/vouchers/new" component={VouchersNew} /> */}
          <Route path="/panel/vouchers/:id/edit" component={VouchersEdit} />

          {/* Me */}
          <Route path="/panel/me" component={Me} />
          <Route path="/panel/export" component={ExportVouchers} />
          <Route path="/panel/reports" component={Reports} />
        </Switch>
      </Container>
    </Box>
  )
}

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        {/* Admin routes */}
        <PrivateRoute path="/admin" component={AdminWrapper} />

        {/* Panel routes */}
        <PrivateRoute path="/panel" component={PanelWrapper} />

        {/* Public routes */}
        <Route exact path="/" component={Login} />
        <Route component={NotFoundPage} />
      </Switch>
    </BrowserRouter>
  )
}

export default Router
